import React from 'react';
import { GlobalStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { border, rem } from '@core-web/typography';
import { ScrollBarStyle } from '@core-web/ui';

const GlobalStyle = () => {
  const { palette } = useTheme(); // Access the MUI theme

  return (
    <GlobalStyles
      styles={{
        '.multiSelect': {
          zIndex: `${99999} !important`,
          ' .MuiPaper-root': {
            overflowX: 'unset',
            overflowY: 'unset',
            padding: rem(8),
            width: 'min-content',
          },
          ' .MuiList-root': {
            overflowY: 'auto',
            maxHeight: rem(282),
            ...ScrollBarStyle(palette),
            paddingTop: rem(0),
            paddingBottom: rem(0),

            'li.MuiButtonBase-root:not(:last-child)': {
              borderBottom: border(1, 'solid', palette.colors.black_50),
            },
            'li.MuiButtonBase-root:first-of-type': {
              padding: `${rem(12)} ${rem(16)}`,
            },
            'li.MuiButtonBase-root:not(:first-of-type)': {
              paddingLeft: rem(8),
            },
            'li.MuiButtonBase-root': {
              backgroundColor: 'transparent',
              whiteSpace: 'unset',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              'span.MuiCheckbox-root': {
                color: palette.colors.blue_700,
                backgroundColor: 'transparent',
                padding: rem(5),
                svg: {
                  width: rem(23),
                  height: rem(23),
                },
              },
            },
          },
        },
        '.MuiModal-root.pageSizeSelector': {
          zIndex: 8005,
        },
        '.MuiPickersPopper-root': {
          zIndex: `12000 !important`,
        },
      }}
    />
  );
};

export { GlobalStyle, GlobalStyle as default };
